import React, { useState, useEffect } from 'react';
import StripeCheckout from "react-stripe-checkout";
import { useNavigate } from 'react-router-dom';
import axios from "axios";

const KEY = "pk_test_51KRaBbSJNXS0kzEEHKUcZ2tXkH1CVSANu2fv1HA2n2wm5FglfER7Be5J2dPYzWcbCN1nKpFjoz567SdSzfqmmL1D00DRGCmYJK"

const Pay = () => {
    const [stripeToken, setStripeToken] = useState(null);
    const history = useNavigate();

    const onToken = (token) => {
        console.log("upper console token",token);
        setStripeToken(token)
    }

    useEffect(() => {
        const makeRequest = async () => {
            try{
                const res = await axios.post("http://localhost:5000/api/checkout/payment", {
                    tokenId: stripeToken.id,
                    amount: 2000,
                  }
                );
                console.log(res.data);
                history.push("/success");
            }
            catch(err){
                console.log(err)
            }
        };
        stripeToken && makeRequest();
    }, [stripeToken, history])

    return (
        <div style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }}>
            {stripeToken ? (<span>Processing... please wait</span>) : (

            <StripeCheckout 
                name="Three Comma Co."
                image="https://www.vidhub.co/assets/logos/vidhub-icon-2e5c629f64ced5598a56387d4e3d0c7c.png"
                shippingAddress
                billingAddress
                description="your total amount is 20"
                amount={200}
                token={onToken}
                stripeKey={KEY}
            >
                <button style={{
                    border: "none",
                    width: "120",
                    padding: "20px",
                    background: "black",
                    color: "white",
                    cursor: "pointer"
                }}>Pay Now</button>
            </StripeCheckout>
            )}
        </div>
    )
}

export default Pay;